module.exports = __webpack_public_path__ + "/images/ico-info-circle.27cd73f.svg";